import React from 'react';
const Governance = () => {
    return (
         <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                         <div className="row mt-4">
                    <div className="col col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="careers-benefits">
                            <h3>How MTJ Advisory Stands with Global Sharia Advisory Firms?</h3>
                            <ul>
                                <li>Independent Sharia advisory (not product selling)</li>
                                <li>Alignment with AAOIFI, IFSB, and regulatory expectations</li>
                                <li>Strong focus on SMEs alongside institutional clients</li>
                                <li>Practical, implementation driven approach (not academic only)</li>
                                <li>Cost effective and scalable service model</li>
                                <li>Hands on support from structuring to audit and certification</li>
                            </ul>
                             <p>
                            MTJ Advisory combines the governance depth of global firms with the agility and accessibility required by growing businesses.
                            </p>
                        </div>
                       
                    </div>
                    <div className="col col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="careers-benefits">
                            <h3>INDUSTRIES WE SERVE</h3>
                            <ul>
                                <li>Small & Medium Enterprises (SMEs)</li>
                                <li>Corporates & Family Owned Businesses</li>
                                <li>Financial Institutions & NBFCs</li>
                                <li>Islamic Fintechs & Digital Platforms</li>
                                <li>Investment Companies & Funds</li>
                                <li>Charitable & Social Impact Organizations</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <h3 className="text-center mt-5" style={{color: '#DB9E30'}}>GOVERNANCE</h3>
                <p className="text-center">MTJ Advisory supports organizations in establishing strong Sharia governance frameworks that ensure independence, accountability, and regulatory compliance. Our governance solutions are aligned with international standards and tailored to the organization’s size, complexity, and jurisdiction.</p>

                       
                    </div>                
                </div>
            </div> 
    )
}
export default Governance;
